import { ArrowRight, Clock3, Fingerprint, Scale, ShieldAlert } from 'lucide-react';
import { CASE_001, characterById } from '../case/case001';
import { useGame } from '../game/GameContext';
import { BrandMark } from './BrandMark';

export function BriefingScreen() {
  const { dispatch } = useGame();
  const lyra = characterById.lyra;
  return (
    <main className="briefing screen-layer">
      <header className="briefing__header"><BrandMark compact /><span>COUNSEL BRIEF / SEALED</span></header>
      <div className="briefing__grid">
        <section className="briefing__portrait">
          <img src={lyra.portrait} alt={lyra.name} />
          <div className="portrait-index"><span>CLIENT</span><strong>LYRA VALE</strong><small>SYNTHETIC PERSON / CURATOR</small></div>
        </section>
        <section className="briefing__case">
          <p className="eyebrow">Tribunal docket {CASE_001.id}</p>
          <h1>{CASE_001.title}</h1>
          <p className="briefing__subtitle">{CASE_001.subtitle}</p>
          <blockquote>
            “My client is lying. Your job is to prove that the lie is not the murder.”
          </blockquote>
          <div className="briefing__facts">
            <div><ShieldAlert /><span>Charge</span><strong>{CASE_001.charge}</strong></div>
            <div><Clock3 /><span>Incident</span><strong>{CASE_001.incidentTime}</strong></div>
            <div><Fingerprint /><span>State theory</span><strong>Only Lyra’s keyprint entered</strong></div>
          </div>
          <div className="briefing__stakes">
            <span><Scale /> WHAT THE VERDICT COSTS</span>
            <p>{CASE_001.stakes}</p>
          </div>
          <button className="primary-action primary-action--large briefing__accept" onClick={() => dispatch({ type: 'ENTER_ARCHIVE' })}>
            Accept mandate & enter Archive Nine <ArrowRight size={19} />
          </button>
          <div className="briefing__anchors" aria-label="Real-world reasoning anchors">
            <header><span>REAL-WORLD EVIDENCE LOGIC</span><small>Composite fiction · authentic reasoning</small></header>
            <div>
              {CASE_001.realityAnchors.map((anchor) => (
                <article key={anchor.label}><strong>{anchor.label}</strong><p>{anchor.detail}</p></article>
              ))}
            </div>
            <blockquote>{CASE_001.fairPlayPromise}</blockquote>
          </div>
          <div className="briefing__mandate">
            <span>COUNSEL MANDATE</span>
            <ol>
              <li>Walk Archive Nine and preserve physical evidence.</li>
              <li>Question every person whose memory touches 21:17.</li>
              <li>Separate the provable verdict from the hidden truth.</li>
            </ol>
          </div>
        </section>
      </div>
    </main>
  );
}
